module.exports = __webpack_public_path__ + "img/vegetable-corn-190x100.5cf98a65.jpg";